export default __webpack_public_path__ + "static/media/threebigcards_restaurant_3.0bec4e7f.png";